import { useCallback, useMemo } from 'react';

import type { UseBundlePreviewDataProps } from '../types';
import { buildCurrentBundle, buildOfferData } from '../utils';

/**
 * Custom hook to generate dynamic preview data for bundle offers
 * Constructs the preview data structure from form values in real-time
 */
export const useBundlePreviewData = ({
  values,
  getOfferUI,
  productsListForPreview,
  badges,
  emblemBadges,
  ribbonBadges,
  transformPriceValue
}: UseBundlePreviewDataProps) => {
  const stableTransformPriceValue = useCallback(() => {
    return transformPriceValue();
  }, [transformPriceValue]);

  const dynamicOfferData = useMemo(() => {
    if (!values.offerUiId || !getOfferUI.data) {
      return null;
    }

    const currentBundle = buildCurrentBundle({
      values,
      getOfferUI: getOfferUI.data,
      productsListForPreview,
      badges,
      emblemBadges,
      ribbonBadges,
      transformPriceValue: stableTransformPriceValue
    });

    return buildOfferData(currentBundle);
  }, [
    values,
    getOfferUI.data,
    productsListForPreview,
    badges,
    emblemBadges,
    ribbonBadges,
    stableTransformPriceValue
  ]);

  return dynamicOfferData;
};
